<template>
  <div class="container mt-5">
    <table class="table">
      <thead>
        <tr>
          <th scope="col">
            <b-icon icon="chevron-left" @click="changeDate(-1)"></b-icon>{{ startDate }}-{{ endDate }}
            <b-icon icon="chevron-right" @click="changeDate(1)"></b-icon>
          </th>
          <th scope="col">預約時間</th>
          <th scope="col">課程名稱</th>
          <th scope="col">課程費用</th>
          <th scope="col">預約</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="reservations.length === 0">
          <td colspan="5" class="text-center" style="height: 500px; vertical-align: middle; color: black">
            無課程可預約
          </td>
        </tr>
        <tr v-else v-for="(item, index) in reservations" :key="index">
          <th scope="row">{{ item.Supldt }} {{ getWeekday(item.Supldt) }}</th>
          <td>{{ item.Supltmfrom }}~{{ item.Supltmto }}</td>
          <td>{{ item.Name }}</td>
          <td>{{ item.Pricing }}</td>
          <td v-if="item.CanRsv === '1'">
            <b-form-checkbox v-model="item.checked"></b-form-checkbox>
          </td>
          <td v-else style="color: red">預約已滿</td>
        </tr>
      </tbody>
    </table>
    <button class="p-2 br-4 orange-btn" @click="showConfirm" style="font-size: 1.75rem">
      確定預約
    </button>
    <b-modal ref="spa-reserved" hide-footer hide-header style="width: 1000px !important">
      <div class="d-flex justify-content-end">
        <b-icon icon="x-circle-fill" style="color: #ec6c01; cursor: pointer" @click="hideReservedConfirm"></b-icon>
      </div>
      <div class="center column">
        <div v-if="checkMsg && checkMsg.length && checkMsg[0] !== ''" class="center column mb-4">
          <div class="red bold f24">相同時段已有預約</div>
          <div class="bold mt-4 f22">
            <div v-for="(msg, index) in checkMsg" :key="index">
              {{ msg }}
            </div>
          </div>
        </div>
        <div class="orange bold f24">請確認您所選的資訊及時間正確無誤</div>
        <div class="bold mt-4 f22">
          <div v-if="selectedItems.length">
            <div v-for="(item, index) in selectedItems" :key="index">
              {{ item.Supldt }} {{ getWeekday(item.Supldt) }}
              {{ item.Supltmfrom }}~{{ item.Supltmto }}
              {{ item.Name }}
            </div>
          </div>
        </div>
        <button type="button" class="orange-btn mt-4 w-100 p-2 f24" @click="saveReserved">
          確定預約
        </button>
        <button type="button" class="btn btn-light mt-3 w-100 f24" style="border: 1px solid black"
          @click="hideReservedConfirm">
          返回修改
        </button>
      </div>
    </b-modal>
    <b-modal ref="confirm-reserved" hide-footer hide-header>
      <div class="d-flex justify-content-end">
        <b-icon icon="x-circle-fill" style="color: #ec6c01; cursor: pointer" @click="hideConfirmReserved"></b-icon>
      </div>
      <div class="center column">
        <div class="bold mt-4 orange center column f24">
          <div>您已預約完成</div>
          <div>可至個人行事曆查看</div>
        </div>
        <button type="button" class="orange-btn mt-4 w-100 p-2 f24" @click="hideConfirmReserved">
          確定
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import 'moment/locale/zh-tw';

export default {
  data() {
    return {
      selectedDate: null,
      startDate: null,
      endDate: null,
      selectedItems: '',
      reservations: [],
      confirmData: {},
      checkMsg: '',
      IS_ON_FIRST_PAGE: false
    };
  },
  created() {
    var savedData = localStorage.getItem('confirm_data');
    this.confirmData = JSON.parse(savedData);

    var { start, end } = this.confirmData;

    if (start && end) {
      this.startDate = start;
      this.endDate = end;
      this.selectedDate = start;
      this.updateReservations(start, end);
    }
  },
  mounted() {
    window.addEventListener("message", this.handleMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    handleMessage(event) {
      console.log("Received message event:", event);
      console.log("Message data:", event.data);

      if (event.data === "backButtonClick") {
        if (this.IS_ON_FIRST_PAGE) {
          parent.postMessage("goToHome", "*");
        } else {
          // Vue Router 返回上一頁
          this.$router.back();
        }
      }
    },
    updateReservations(start, end) {
      var formattedStart = moment(start).format('YYYY/MM/DD');
      var formattedEnd = moment(end).format('YYYY/MM/DD');
      var post_data = {
        searchData: this.$Global.Base64Utils.utoa(
          JSON.stringify({
            ShopNO: this.$Global.Base64Utils.atou(
              this.$cookieFunc.getCookie('ShopNO')
            ),
            Flowno: this.confirmData.Flowno,
            SupldtF: formattedStart,
            SupldtT: formattedEnd,
            SnB: this.confirmData.SnB,
            SnC: this.confirmData.SnC
          })
        )
      };

      this.$axios({
        method: 'post',
        url: this.$URLJson.GetCanRsvClass,
        data: post_data
      })
        .then((res) => {
          var data = JSON.parse(this.$Global.Base64Utils.atou(res.data));
          console.log(data)
          this.reservations = data;
          //console.log(this.reservations);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    showConfirm() {
      this.selectedItems = this.reservations.filter((item) => item.checked);
      this.checkSpaRSV();
      if (this.selectedItems.length > 0) {
        this.$refs['spa-reserved'].show();
      } else {
        this.$parent.Msg('請勾選時段', '5', 'warning');
        return;
      }
    },

    hideReservedConfirm() {
      this.$refs['spa-reserved'].hide();
    },

    checkSpaRSV() {
      var orderFields = {
        Orderno: '',
        Flowno: '',
        Homeid: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Homeid')
        ),
        Userid: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Userid')
        ),
        UserName: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('UserName')
        ),
        Mobile: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Mobile')
        ),
        Createmem: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Userid')
        ),
        Updmem: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Userid')
        )
      };

      var orderItem = this.selectedItems.map((item) => {
        return {
          ...item,
          ...orderFields
        };
      });

      var post_data = {
        searchData: this.$Global.Base64Utils.utoa(JSON.stringify(orderItem))
      };

      this.$axios({
        method: 'post',
        url: this.$URLJson.CheckSpaRSV,
        data: post_data
      })

        .then((res) => {
          var data = JSON.parse(this.$Global.Base64Utils.atou(res.data));
          var parsedData = JSON.parse(data.msg);
          this.checkMsg = parsedData;
        })
        .catch(function (error) {
          // 請求失敗處理
          console.log(error);
        });
    },

    saveReserved() {
      const url = window.location.href

      const u = new URL(url);
      // 取得路徑
      let pathname = u.pathname; // "/dev_sampo_client_web/SpaReservedMain"
      // 去掉最後一段
      let basePath = pathname.substring(0, pathname.lastIndexOf("/") + 1);

      // 拼回完整網址
      let resultpath = `${u.origin}${basePath}`;

      //console.log(resultpath);
      // https://orange-service.itsesg.work/dev_sampo_client_web/
      var orderFields = {
        Orderno: '',
        Flowno: '',
        Homeid: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Homeid')
        ),
        Userid: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Userid')
        ),
        UserName: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('UserName')
        ),
        Mobile: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Mobile')
        ),
        Createmem: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Userid')
        ),
        Updmem: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Userid')
        ),
        token: localStorage.token,
        url: resultpath + 'SpaReservedMain?token=' + localStorage.token
      };

      var orderItem = this.selectedItems.map((item) => {
        return {
          ...item,
          ...orderFields
        };
      });

      var post_data = {
        searchData: this.$Global.Base64Utils.utoa(JSON.stringify(orderItem))
      };

      this.$axios({
        method: 'post',
        url: this.$URLJson.SaveRSV,
        data: post_data
      })

        .then((res) => {
          var data = JSON.parse(this.$Global.Base64Utils.atou(res.data));
          if (data.check) {
            this.$refs['confirm-reserved'].show();
            this.hideReservedConfirm();

            var start = this.startDate;
            var end = this.endDate;
            this.updateReservations(start, end);
            //console.log(
            //  JSON.parse(this.$Global.Base64Utils.atou(post_data.searchData))
            //);
            //console.log(data);
          } else {
            this.$parent.Msg(data.msg, '5', 'warning');
            return;
          }
        })
        .catch(function (error) {
          // 請求失敗處理
          console.log(error);
        });
    },

    hideConfirmReserved() {
      this.$refs['confirm-reserved'].hide();
    },

    changeDate(offset) {
      var start = moment(this.startDate).add(offset, 'days');
      var end = moment(this.endDate).add(offset, 'days');

      this.startDate = start.format('YYYY-MM-DD');
      this.endDate = end.format('YYYY-MM-DD');
      this.selectedDate = this.startDate;

      this.updateReservations(this.startDate, this.endDate);
    },
    getWeekday(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('zh-TW', { weekday: 'long' });
    }
  },
  computed: {
    dateRangeTitle() {
      if (this.startDate && this.endDate) {
        return `${this.startDate} ~ ${this.endDate}`;
      }
      return this.selectedDate;
    }
  }
};
</script>

<style scoped>
.table thead th {
  background-color: #e0d2d2;
  font-weight: bold;
  color: black;
  padding: 15px;
  font-size: 1.5rem;
}

.table th,
.table td {
  background-color: white;
  color: #6a5050;
  padding: 30px;
  font-size: 1.5rem;
}

.custom-control {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 0.5rem;
}

/deep/ .modal-content {
  width: fit-content;
}

/deep/ .modal-body {
  width: max-content;
}
</style>



// WEBPACK FOOTER //
// src/components/View/Spa/SpaReserved.vue